import {initSlider, initFeatureSlider} from "./common";

$(function() {
  initSlider();

  setTimeout(() => {
    initFeatureSlider()
  }, 2000);

  const delayedExec = function(after, fn) {
    let timer;
    return function() {
      timer && clearTimeout(timer);
      timer = setTimeout(fn, after);
    };
  };

  const scrollResize = delayedExec(500, function() {
    initFeatureSlider();
  });

  window.addEventListener('resize', scrollResize);
});
